export default __webpack_public_path__ + "static/dressing.en.cover-0b127834c704da204b1d01f6f76c47f0.jpg";